<div role="status" aria-live="polite" [attr.aria-label]="message"
    class="flex items-center justify-center px-4"
    [ngClass]="{
        'fixed inset-0 z-[70] min-h-[100dvh]': background !== 'container',
        'bg-app-brand-soft': background !== 'container',
        'bg-app-brand-wash': background === 'container',
        'min-h-64 w-full rounded-lg border border-app-brand-border-soft': background === 'container'
    }"
    [ngStyle]="{ 'font-size': fontSize + 'px' }">
    <div class="flex max-w-full flex-col items-center text-center">
        <div class="relative h-16 w-16" aria-hidden="true">
            <div class="absolute inset-0 animate-spin rounded-full border-[3px] border-app-brand-shadow border-r-app-highlight border-t-app-brand motion-reduce:animate-none"></div>
            <div class="absolute inset-[0.55rem] flex items-center justify-center rounded-full border border-app-highlight-line bg-white">
                <img src="/public/icons/icon-48x48.png" alt="" class="h-8 w-8 rounded-md">
            </div>
        </div>

        <p class="mt-4 whitespace-normal font-bold leading-relaxed text-app-ink">{{ message }}</p>
    </div>
</div>
